import { render } from "./SectionChartModal.vue?vue&type=template&id=94b9992a"
import script from "./SectionChartModal.vue?vue&type=script&lang=js"
export * from "./SectionChartModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/insights/SectionChartModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "94b9992a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('94b9992a', __exports__)) {
    api.reload('94b9992a', __exports__)
  }
  
  module.hot.accept("./SectionChartModal.vue?vue&type=template&id=94b9992a", () => {
    api.rerender('94b9992a', render)
  })

}


export default __exports__